import {deserializeAs} from 'cerialize';

export class Pce {

  @deserializeAs('id_pce')
  idPce: number;
}
